// @flow

import { takeLatest, put, call, all, take } from 'redux-saga/effects';
import { store } from './../store';
import type { Saga } from 'redux-saga';
import type { GeneratorType } from 'sagas/root';
import type { ApiExecutorType } from 'types/ApiExecutorType';
import ArticleApi from 'api/article/ArticleApi';
import {
  FETCH_ARTICLES_START,
  FETCH_ARTICLES_BILLBOARD_START,
  FETCH_ARTICLES_CATEGORIES_START,
  articlesFetched,
  articlesFetchError,
  articlesCategoriesFetched,
  articlesCategoriesFetchError
} from 'actions/newsletterActions';
import {FETCH_CATEGORIES_SUCCESS} from 'actions/categoriesActions';

export default function(apiExecutor: ApiExecutorType, staticApiExecutor: ApiExecutorType) {
  const articleApi = new ArticleApi(apiExecutor, staticApiExecutor);

  return function* newsletterSaga(): GeneratorType {
    yield takeLatest(FETCH_ARTICLES_START, fetchArticles);
    yield takeLatest(FETCH_ARTICLES_BILLBOARD_START, fetchArticlesBillboard);
    yield takeLatest(FETCH_ARTICLES_CATEGORIES_START, fetchArticlesCategories);
  };

  function* fetchArticles(action): Saga<void> {
    try {
      const { page, per_page } = action.payload;
      const article = yield call(articleApi.fetchArticlesByPage, page, per_page);
      yield put(articlesFetched(article));
    } catch (e) {
      yield put(articlesFetchError(e));
    }
  }

  function* fetchArticlesBillboard(action): Saga<void> {
    try {
      const article = yield call(articleApi.fetchArticlesLast);
      yield put(articlesFetched(article));
    } catch (e) {
      yield put(articlesFetchError(e));
    }
  }

  function* fetchArticlesCategories(action): Saga<void> {
    try {
      const { page, per_page } = action.payload;
      const {categoriesState} = store.getState();
      let categories = [];
      if (categoriesState.categories.length === 0) {
        const success = yield take(FETCH_CATEGORIES_SUCCESS);
        categories = success.payload.categories;
      } else {
        categories = categoriesState.categories;
      }
      yield all(categories.map(category => {
        return call(articleApi.fetchArticleByCategory, page, per_page, category);
      }));
      yield put(articlesCategoriesFetched(categories));
    } catch (e) {
      yield put(articlesCategoriesFetchError(e));
    }
  }
}
